module.exports = __webpack_public_path__ + "img/discord.55febd34.svg";